<template>
    <!-- Add Modal -->
<div class="modal fade p-0" id="addInventory" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-lg">
		<div class="d-flex flex-wrap w-100 position-relative event-auto">
			<div class="card shadow-none">
				<Form @submit="onSubmit" @keydown="errors_v.clear($event.target.name)" :validation-schema="schema" class="custom-form mt-2 assign-shops" ref="myForm">
                    <div class="card-header card-header-primary d-flex flex-wrap align-items-center position-relative">
                        <div class="content-card-left w-100">
                            <h4 class="card-title text-white fs-4">{{ editMode ? 'Edit Inventory' : 'Inventory In' }}</h4>
                            <p class="fw-light text-white mb-0 pt-1">{{ editMode ? 'Update Inventory Entry' : 'Add Products To Inventory' }}</p>
                        </div>
                    </div>
                    <div class="card-body" >

                            <div class="row">
                                <div class="col-12 mb-4">
                                    <div class="position-relative form-group">
                                        <Field as="select" name="company_id" class="form-select custom-select" @click="selectFocus = true" v-model="company_model" :disabled="editMode">
                                            <option value="0">Choose Company</option>
                                            <option v-for="company in companies" :value="company.id" :key="company.id">{{company.name}}</option>
                                        </Field>
                                        <label :class="[selectFocus ? 'focus':'', 'position-absolute select-label']">Company</label>
                                        <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                        
                                        <ErrorMessage class="invalid-message mb-0 pt-2" name="company_id" />
                                        <p v-if="errors_v.get('companyId') && (company_model==null || company_model=='')" class="invalid-message mb-0 pt-2">
											{{errors_v.get('companyId')}}
										</p>
                                    </div>
                                </div>
                                <!-- Inventory Date -->
                                <div class="col-12 mb-4">
                                    <v-date-picker
                                        class="custom-calendar custom-single-calendar left-caret-none"
                                        v-model="inventoryDate"
                                        :disabled="editMode"
                                        :masks="{ input: 'DD/MM/YY' }"
                                    >
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <div class="position-relative calendar-input-wrapper clearfix w-100">
                                                <span class="d-inline-block me-2 float-left">Date</span>
                                                <i class="bi bi-calendar3 position-absolute icon-left-placement"></i>
                                                <input
                                                    class="icon-left position-relative float-left w-100"
                                                    :value="inputValue"
                                                    v-on="inputEvents"
                                                    :disabled="editMode"
                                                />
                                            </div>
                                        </template>
                                    </v-date-picker>
                                </div>
                                <!-- Company invoice number: one per bill (optional for now) -->
                                <div class="col-12 mb-4" v-if="!editMode">
                                    <div class="position-relative">
                                        <input type="text" name="invoiceNumber" maxlength="50" :class="[invoiceNumber=='' ? '' : 'active', 'border-input position-relative w-100']" v-model="invoiceNumber"/>
                                        <label for="" class="mb-0 placeholder-label w-auto">Invoice Number</label>
                                        <p v-if="errors_v.get('invoiceNumber')" class="invalid-message mb-0 pt-2">
                                            {{errors_v.get('invoiceNumber')}}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <fieldset class="InputGroup row" v-for="(user, idx) in users" :key="user.id">
                                    <div class="col-12" v-if="idx==0 && !editMode">
                                        <div class="d-flex flex-wrap aligm-items-center mb-3">
                                            <h6 class="mb-0 text-primary">Products{{ idx+1 }}</h6>
                                            <div class="text-center align-self-center add-rows-wrapper ms-auto">
                                                <span class="d-inline-block add bi bi-plus-circle-fill text-primary" @click="add"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12" v-else-if="!editMode">
                                        <div class="d-flex flex-wrap aligm-items-center mb-3">
                                            <h6 class="mb-0 text-primary">Products{{ idx+1 }}</h6>
                                            <div class="text-center align-self-center add-rows-wrapper ms-auto">
                                                <span class="d-inline-block add bi bi-dash-circle-fill text-primary" @click="remove(user)"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 mb-3 col-12">
                                        <Multiselect @select="changeMultiselect(user.product_model,idx)"
											v-model="user.product_model"
											:options="modalOptions"
											class="custom-multiselect"
											placeholder="Products"
											:searchable="true"
											:showOptions="true"
											mode="single"
											label="name"
											trackBy	= "name"
											valueProp="id"
											required: true
											:id="`multiselect_${idx}`"
											:name="`users[${idx}].multiselect`"
										/>
										
										<Field type="hidden" :id="`productid_${idx}`" :name="`users[${idx}].productid`" v-model="values_hidden[idx]" />
                                        <ErrorMessage class="invalid-message mb-0 pt-2" :name="`users[${idx}].productid`" />
                                        <p v-if="errors_v.get('inventoryData.'+idx+'.productid') && (values_hidden[idx]==null || values_hidden[idx]=='')" class="invalid-message mb-0 pt-2">
											{{errors_v.get('inventoryData.'+idx+'.productid')}}
										</p>
                                        
                                    </div>
                                    <div class="col-lg-4 col-md-4 mb-3 col-12">
                                        <div class="position-relative form-group">
                                            <Field as="select" :id="`ptype_${idx}`" :name="`users[${idx}].ptype`" class="form-select custom-select" @click="selectFocus = true" v-model="user.ptype_model" @change="printAmount(idx)">
                                                <option value="cartons">Cartons</option>
                                                <option value="boxes">Boxes</option>
                                            </Field>
                                            <label :class="[selectFocus ? 'focus':'', 'position-absolute select-label']">Quantity In</label>
                                            <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 mb-3 col-12">
                                        <div class="position-relative">
                                            <Field as="input" :id="`quantity_${idx}`" :name="`users[${idx}].quantity`" type="number" :class="[user.quantity_model=='' ? '' : 'active', 'border-input position-relative w-100']" v-model="user.quantity_model" @change="printAmount(idx)"/>
                                            <label for="" class="mb-0 placeholder-label w-auto">Quantity</label>
                                            <p v-if="errors_v.get('inventoryData.'+idx+'.quantity') && (user.quantity_model==null || user.quantity_model=='')"  class="invalid-message mb-0 pt-2">
                                                {{errors_v.get('inventoryData.'+idx+'.quantity')}}
                                            </p>
                                            <ErrorMessage class="invalid-message mb-0 pt-2" :name="`users[${idx}].quantity`" />
                                        </div>
                                    </div>

                                    <!-- Extra quantity that should NOT affect amount, only inventory quantity -->
                                    <div class="col-lg-4 col-md-4 mb-3 col-12">
                                        <div class="position-relative form-group">
                                            <Field as="select" :id="`extra_ptype_${idx}`" :name="`users[${idx}].extra_ptype`" class="form-select custom-select" @click="selectFocus = true" v-model="user.extra_ptype_model">
                                                <option value="boxes">Boxes</option>
                                                <option value="cartons">Cartons</option>
                                            </Field>
                                            <label :class="[selectFocus ? 'focus':'', 'position-absolute select-label']">Extra In</label>
                                            <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 mb-3 col-12">
                                        <div class="position-relative">
                                            <Field as="input" :id="`extra_quantity_${idx}`" :name="`users[${idx}].extra_quantity`" type="number" min="0" :class="[user.extra_quantity_model=='' ? '' : 'active', 'border-input position-relative w-100']" v-model="user.extra_quantity_model" />
                                            <label for="" class="mb-0 placeholder-label w-auto">Extra Quantity</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 mb-3 col-12">
                                        <div class="position-relative">
                                            <Field as="input" :id="`line_discount_${idx}`" :name="`users[${idx}].discount`" type="number" min="0" :class="[user.line_discount_model=='' ? '' : 'active', 'border-input position-relative w-100']" v-model="user.line_discount_model" />
                                            <label for="" class="mb-0 placeholder-label w-auto">Item Discount</label>
                                        </div>
                                    </div>
                                    <!-- Per item amount (gross - item discount), display only -->
                                    <div class="col-lg-4 col-md-4 mb-3 col-12">
                                        <div class="position-relative">
                                            <input
                                                type="number"
                                                :class="[((Number(user.amount||0)-Number(user.line_discount_model||0))>0) ? 'active' : '', 'border-input position-relative w-100']"
                                                :value="Math.max(0, (Number(user.amount || 0) - Number(user.line_discount_model || 0))).toFixed(2)"
                                                disabled
                                            />
                                            <label for="" class="mb-0 placeholder-label w-auto">Amount</label>
                                        </div>
                                    </div>
                                    
                                </fieldset>
                                </div>
                           
                                
                            </div>

                                    <div class="row mt-3">
                                        <div class="col-12">
                                            <p class="mb-0 text-primary fw-semibold">
                                                Total Entered &mdash; Cartons: {{ totalEntered.cartons }} &nbsp;|&nbsp; Boxes: {{ totalEntered.boxes }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row mt-3">

                                        <div class="col-auto ms-auto">
                                            <div class="position-relative">
                                                <input type="number"   :class="[users.freight=='' ? '' : 'active', 'border-input position-relative w-100']" v-model="users.freight"/>
                                                <label for="" class="mb-0 placeholder-label w-auto">Freight</label>
                                            </div>
                                        </div>

                                        <div class="col-auto ms-auto">
                                            <div class="position-relative">
                                                <input type="number"   :class="[users.discount=='' ? '' : 'active', 'border-input position-relative w-100']" v-model="users.discount"/>
                                                <label for="" class="mb-0 placeholder-label w-auto">Discount</label>
                                            </div>
                                        </div>

                                     <div class="col-auto">
                                        <div class="position-relative">
                                            <input type="number"   :class="[users.discount=='' ? '' : 'active', 'border-input position-relative w-100']" v-model="users.total_amount"/>
                                            <label for="" class="mb-0 placeholder-label w-auto">Total Amount</label>
                                            
                                        </div>
                                      </div>
                                   </div>
                    </div>
                   
                    <div class="card-footer px-4 pb-0 border-0 bg-transparent mb-3">
                        <button class="btn btn-primary w-100" :disabled="searchDisabled">
                            <div v-if="loader" class="spinner-border me-2" role="status"></div>{{ editMode ? 'Update Inventory' : 'Add Inventory' }}
                        </button>
                    </div>
                </Form>
			</div>
		</div>
	</div>			
</div>
</template>
<script>
import Multiselect from '@vueform/multiselect';
import {Form, Field, ErrorMessage} from 'vee-validate';
import {ref, reactive, onMounted, watch, computed} from 'vue';
import CompanyServices from '@/services/CompanyServices';
import ProductServices from '@/services/ProductServices';
import * as yup from "yup";
import InventoryServices from '@/services/InventoryServices';
import Errors from "@/utils/Errors";
export default {
    components:{
        Multiselect,
        Form,
        Field,
        ErrorMessage
    },
    props: {
        editMode: { type: Boolean, default: false },
        editId: { type: [Number, String], default: null },
    },
    setup(props,{emit}){
        const companies=ref([]);
        const company_model=ref(0);
        const modalOptions = ref("");
        const loader=ref(false);
        const searchDisabled=ref(false);
        const inventoryDate = ref(new Date());
        const invoiceNumber = ref("");
        const users=ref([{
            id: Date.now(),
            product_model: "",
            ptype_model: 'cartons',
            quantity_model: "",
            amount:"",
            total_amount: "",
            discount:"0",
            freight:"0",
            extra_ptype_model: 'boxes',
            extra_quantity_model: "",
            line_discount_model: "0"
        }]);
        // Also track bill-level fields on the array object (used by v-model bindings)
        users.value.discount = "0";
        users.value.freight = "0";
        users.value.total_amount = "";
        const values_hidden=ref({});
        const errors_v = reactive(new Errors());
        const originalBoxesQty = ref(null); // original stored quantity in boxes for edit mode
        const hasStoredBreakdown = ref(false);

        // Running tally of the quantities entered across all product rows, split by
        // unit (main + extra), shown at the bottom of the form.
        const totalEntered = computed(() => {
            let cartons = 0, boxes = 0;
            (users.value || []).forEach((u) => {
                const q = Number(u.quantity_model) || 0;
                const eq = Number(u.extra_quantity_model) || 0;
                if (u.ptype_model === 'cartons') cartons += q; else boxes += q;
                if (u.extra_ptype_model === 'cartons') cartons += eq; else boxes += eq;
            });
            return { cartons, boxes };
        });


        const schema = yup.object().shape({
            company_id: yup.number().moreThan(0, 'Company Name Required'),
            users: yup
                .array()
                .of(
                yup.object().shape({
                    productid: yup.number().required().label("Product Name"),
                    quantity: yup.number().moreThan(0, 'Product Quantity Required').typeError("Only Numbers Allowed").label("Quantity"),
                })
                )
					
		});
        const sum_amount = () => {
            try {
                const gross = (users.value || []).reduce((sum, u) => {
                    const a = Number(u.amount || 0);
                    return sum + (isNaN(a) ? 0 : a);
                }, 0);
                const lineDisc = (users.value || []).reduce((sum, u) => {
                    const d = Number(u.line_discount_model || 0);
                    return sum + (isNaN(d) ? 0 : d);
                }, 0);
                const billDisc = Number(users.value.discount || 0);
                const freight = Number(users.value.freight || 0);
                const net = gross - lineDisc - billDisc - freight;
                users.value.total_amount = net > 0 ? net : 0;
            } catch (e) {
                users.value.total_amount = 0;
            }
        }

         const printAmount=(idx)=>{
            const product_id=values_hidden.value[idx];
            const obj = modalOptions.value.find(o => o.id === product_id);
            let quantity=users.value[idx].quantity_model;
            const ptype=users.value[idx].ptype_model;
            if(ptype==="cartons"){
                quantity = eval(quantity)*eval(obj.boxes_per_carton);            
            }
            if(product_id>0 && quantity>0){
                users.value[idx].amount=obj.initial_price_per_unit*quantity;
               sum_amount()
            }
            else{
                users.value[idx].amount="";
            }
        
         }
        const add= ()=>{
            
            users.value.push({
                id: Date.now(),
                product_model: "",
                ptype_model: 'cartons',
                quantity_model: "",
                extra_ptype_model: 'boxes',
                extra_quantity_model: "",
                line_discount_model: "0"
            });
           sum_amount();
		}

        const remove=(item)=>{
            const index = users.value.indexOf(item);
            if (index === -1){
                return;
            }
            users.value.splice(index, 1);
            sum_amount()

        }
        onMounted(async () => {
            await CompanyServices.paginateCompanies()
            .then(response=>{
                companies.value= response.data.data;
            })
		});
        // Recalculate totals when any nested field changes
        watch(users, () => { sum_amount(); }, { deep: true });
        // Ensure we recalc when bill-level fields change explicitly
        watch(() => users.value.discount, () => { sum_amount(); });
        watch(() => users.value.freight, () => { sum_amount(); });
        function resetCustomForm() {
            users.value.length=0;
            users.value=[{
                id: Date.now(),
                product_model: "",
                ptype_model: 'cartons',
                quantity_model: "",
                extra_ptype_model: 'boxes',
                extra_quantity_model: "",
                line_discount_model: "0"
            }]
            // reset array-level fields for the bill
            users.value.discount = "0";
            users.value.freight = "0";
            users.value.total_amount = "";
            values_hidden.value={};
            inventoryDate.value = new Date();
            invoiceNumber.value = "";
            sum_amount();
        }
        watch(()=>company_model.value, (currentValue, oldValue) => {
          if(currentValue!=oldValue && currentValue!=""){
			ProductServices.CompanyProducts(company_model.value)
            .then(response=>{
                 modalOptions.value= response.data;
            })
            resetCustomForm(); 
          }
        });
        async function prefillFromApi(id) {
            try {
                // load companies if not loaded
                if (!companies.value || companies.value.length === 0) {
                    const res = await CompanyServices.paginateCompanies();
                    companies.value = res.data.data;
                }
                const resp = await InventoryServices.getInventory(Number(id));
                const row = resp.data;
                company_model.value = row.company_id;
                const r = await ProductServices.CompanyProducts(company_model.value);
                modalOptions.value = r.data;
                originalBoxesQty.value = parseFloat(row.quantity || 0) || 0;
                // Prefill date
                try { inventoryDate.value = new Date(row.created_at); } catch (e) { inventoryDate.value = new Date(); }
                const baseType = row.base_packing_type || row.packing_type || 'boxes';
                let baseQty = row.base_quantity != null ? parseFloat(row.base_quantity) : null;
                const bpc = parseFloat(row.boxes_per_carton || 1) || 1;
                if (baseQty == null || isNaN(baseQty)) {
                    if (baseType === 'cartons' && bpc) {
                        baseQty = Math.floor(originalBoxesQty.value / bpc);
                    } else {
                        baseQty = originalBoxesQty.value;
                    }
                }
                users.value = [{
                    id: Date.now(),
                    product_model: row.product_id,
                    ptype_model: baseType,
                    quantity_model: baseQty,
                    amount: '',
                    total_amount: '',
                    discount: row.parent_inventory.total_discount || '0',
                    freight: row.parent_inventory.total_freight || '0',
                    extra_ptype_model: row.extra_packing_type || 'boxes',
                    extra_quantity_model: row.extra_quantity != null ? parseFloat(row.extra_quantity) : '',
                    // Prefill individual line discount if present
                    line_discount_model: (row.item_discount != null ? String(row.item_discount) : "0")
                }];
                // Prefill form bindings for Freight/Discount at the array level used by the template
                users.value.discount = String(row.parent_inventory.total_discount || '0');
                users.value.freight = String(row.parent_inventory.total_freight || '0');
                console.log(users.value, 'prefilled inventory edit')

                // mark if breakdown exists
                hasStoredBreakdown.value = (row.base_quantity != null) || (row.extra_quantity != null);
                values_hidden.value = { 0: row.product_id };
                // compute amount from product price (initial price)
                const prodInList = (modalOptions.value || []).find(o => o.id === row.product_id);
                if (prodInList) {
                    let q = users.value[0].quantity_model;
                    if (baseType === 'cartons') q = q * parseFloat(prodInList.boxes_per_carton || 1);
                    users.value[0].amount = prodInList.initial_price_per_unit * q;
                    sum_amount();
                }
            } catch (e) { /* ignore */ }
        }
        watch(() => props.editId, async (editId) => {
            if (!editId) return;
            await prefillFromApi(editId);
        });

        // Keep base quantity adjusted when extra changes in edit mode to preserve stock qty
        const applyExtraAdjustment = () => {
            try {
                if (!props.editMode || originalBoxesQty.value === null) return;
                const u = users.value[0];
                const pid = values_hidden.value[0];
                const prod = (modalOptions.value || []).find(o => o.id === pid) || {};
                const bpc = parseFloat(prod.boxes_per_carton || 1);
                const baseType = u.ptype_model || 'boxes';
                const extraType = u.extra_ptype_model || 'boxes';
                const extraQty = parseFloat(u.extra_quantity_model || 0) || 0;
                // convert extra to boxes based on baseType vs extraType relationship
                let extraBoxes = extraQty;
                if (baseType === 'boxes' && extraType === 'cartons') extraBoxes = extraQty * bpc;
                if (baseType === 'cartons' && extraType === 'boxes') extraBoxes = bpc ? (extraQty / bpc) : 0;
                // target base boxes to keep total constant
                let baseBoxes = originalBoxesQty.value - (isNaN(extraBoxes) ? 0 : extraBoxes);
                if (baseBoxes < 0) baseBoxes = 0;
                // set displayed base quantity in selected base unit
                if (baseType === 'cartons' && bpc) {
                    u.quantity_model = baseBoxes / bpc;
                } else {
                    u.quantity_model = baseBoxes;
                }
                // refresh amount
                printAmount(0);
            } catch (e) { /* ignore */ }
        };

        // Set by prefillFromApi
        watch(() => [props.editMode, users.value[0] && users.value[0].extra_ptype_model, users.value[0] && users.value[0].extra_quantity_model, users.value[0] && users.value[0].ptype_model], () => {
            // Only auto-adjust if no stored breakdown exists (legacy rows)
            if (!hasStoredBreakdown.value) applyExtraAdjustment();
        });

        const effectiveQtyDisplay = computed(() => {
            // Show original boxes quantity in current base unit with extra breakdown
            try {
                if (!props.editMode || originalBoxesQty.value === null) return '';
                const u = users.value[0];
                const pid = values_hidden.value[0];
                const prod = (modalOptions.value || []).find(o => o.id === pid) || {};
                const bpc = parseFloat(prod.boxes_per_carton || 1);
                const baseType = u.ptype_model || 'boxes';
                let eff = originalBoxesQty.value;
                if (baseType === 'cartons' && bpc) eff = eff / bpc;
                return `${eff} ${baseType}`;
            } catch (e) { return ''; }
        });
        function changeMultiselect(value,idx){
			values_hidden.value[idx]=value;
           
		}
        const closeModal= ()=>{
            const myModalEl = document.getElementById('addInventory');
            const modal = window.bootstrap.Modal.getInstance(myModalEl);
            modal.hide();
        }
        

        const onSubmit = async(values, actions) => {
            loader.value=true;
            searchDisabled.value=true;
			//alert(errors);
			//alert(JSON.stringify(errors, null, 2));
            // Build inventory items with extra quantity added (for stock) but not affecting amount
            const inventoryItems = (values.users || []).map((u, idx) => {
                const pid = values_hidden.value[idx];
                const prod = (modalOptions.value || []).find(o => o.id === pid) || {};
                const bpc = parseFloat(prod.boxes_per_carton || 1);
                const baseType = u.ptype || 'boxes';
                const baseQty = parseFloat(u.quantity || 0) || 0;
                const extraType = u.extra_ptype || (users.value[idx] ? users.value[idx].extra_ptype_model : 'boxes');
                const extraQty = parseFloat(u.extra_quantity || 0) || 0;
                const lineDiscount = parseFloat(users.value[idx]?.line_discount_model || 0) || 0;
                let extraInBase = extraQty;
                if (baseType === 'boxes' && extraType === 'cartons') {
                    extraInBase = extraQty * bpc;
                } else if (baseType === 'cartons' && extraType === 'boxes') {
                    extraInBase = bpc ? (extraQty / bpc) : 0;
                }
                const adjQty = baseQty + (isNaN(extraInBase) ? 0 : extraInBase);
                return {
                    productid: pid,
                    quantity: adjQty,
                    ptype: baseType,
                    extra_ptype: extraType,
                    extra_quantity: extraQty,
                    base_quantity: baseQty,
                    discount: lineDiscount,
                };
            });
            const formatDateYMD = (d) => {
                try {
                    if (!d) return '';
                    const dt = new Date(d);
                    const y = dt.getFullYear();
                    const m = String(dt.getMonth()+1).padStart(2,'0');
                    const da = String(dt.getDate()).padStart(2,'0');
                    return `${y}-${m}-${da}`;
                } catch (e) { return ''; }
            };
            let payload={
                "inventoryData": inventoryItems,
                "companyId": values.company_id,
                "invoiceNumber": invoiceNumber.value.trim(),
                "totalAmount":users.value.total_amount,
                "discount":users.value.discount || 0,
                "freight" : users.value.freight || 0,
                "date": formatDateYMD(inventoryDate.value)
            }
            
            if(company_model.value===0){
                 payload={
                    "inventoryData": values.users,
                    "companyId": ""
				}
            
            }
            
            try {
                if (props.editMode && props.editId) {
                    // Send full store-like payload for update
                    await InventoryServices.updateInventory(Number(props.editId), payload);
                    emit('alertEvent', 'edit');
                    emit('closeEdit');
                } else {
                    await InventoryServices.addInventories(payload);
                    emit('alertEvent', 'add');
                }
                closeModal();
                actions.resetForm();
                resetCustomForm();
            } catch (error) {
                if (error && error.response && error.response.status==422){
                    errors_v.record(error.response.data.errors);
                }
            } finally {
                loader.value=false;
                searchDisabled.value=false;
            }
				
			}
        return {
            users,
            add,
            remove,
            totalEntered,
            companies,
            company_model,
            modalOptions,
            changeMultiselect,
            values_hidden,
            onSubmit,
            schema,
            errors_v,
            closeModal,
            loader,
            searchDisabled,
            resetCustomForm,
            printAmount,
            effectiveQtyDisplay,
            inventoryDate,
            invoiceNumber


        }
    }
}
</script>
